<template>
<div style="height:98%">
    <div class="search-bar-comm-style">
        <input
            type="text"
            v-model="search"
            class="rounded text-light search-bar"
            :placeholder="$t('Search plugin')"/>
        </div>
    <div class="pl-4 pt-0 pr-4 pb-2" style="height:calc(100% - 90px);overflow:auto">
      <table
        class="table-with-border table-scroll small-first-col"
        style="background: transparent">
        <thead style="color: #eee">
          <tr>
            <th style="width:3%"></th>
            <th style="width: 30%" class="text-left">{{$t('Plugin Name')}}</th>
            <th style="width: 10%;text-align:end">{{$t('Version')}}</th>
            <th style="width: 10%;text-align:center">{{$t('Category')}}</th>
            <th style="width: 10%;text-align:center">{{$t('Installed On')}}</th>
            <th style="width: 10%;text-align:center">{{$t('Modified On')}}</th>
            <th style="width: 7%;text-align:center">{{$t('Status')}}</th>
            <!-- <th style="width: 2%"></th> -->
          </tr>
        </thead>
        <tbody class="body-half-screen">
          <tr
            v-for="pluginsList in filteredPlugins"
            :key="pluginsList.plugin_id"
            :id="pluginsList.plugin_id"
            @click="changeComponent(pluginsList)"
            class="comm-user-row show-delete-icon">
            <td style="width:3%">
              <div style="height:30px;width:40px;margin:10px">
                <img :src="pluginsList.thumbnail_path" @error="replaceByDefaultImage" class="h-100 w-100" style="border-radius:5px"/>
              </div>
            </td>
            <td
              class="text-left" style="white-space:nowrap;width:30%">
              {{ pluginsList.plugin_name }}
            </td>
            <td class="text-right">{{pluginsList.plugin_version.version}}</td>
            <td>{{ pluginsList.category }}</td>
            <td :title="getDateAndTimeInConfiguredFormat(pluginsList.created_datetime)">{{ getDateAndTimeInConfiguredFormat(pluginsList.created_datetime, true)}}</td>
            <td :title="getDateAndTimeInConfiguredFormat(pluginsList.modified_datetime)">{{ getDateAndTimeInConfiguredFormat(pluginsList.modified_datetime, true)}}</td>
            <td
              :class="{ activestatus: pluginsList.status === 'active' }"
              style="color: #cb0707; text-transform: capitalize;position:relative">
              {{ pluginsList.status }}
              <a
                class="p-2 parent-row-delete"
                @click.stop.prevent="uninstallPlugin(pluginsList.plugin_id, pluginsList.plugin_name, pluginsList.category)">
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 16 16"
                  class="bi bi-trash-fill"
                  style="margin-inline-end: 4px"
                  fill="#c5c0c0"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7z"
                  />
                </svg>
                {{$t('Uninstall')}}</a>
            </td>
            <!-- <td style="position: relative"> -->
               <!-- <div class="dropdown">
                <div
                  class="nav-item nav-link dropdown-toggle mr-md-2"
                  id="bd-versions"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="true">
                  <svg
                    width="2em"
                    height="1.5em"
                    viewBox="0 0 16 16"
                    class="bi bi-three-dots more-actions-btn"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"/>
                  </svg>
                </div>
                <div
                  class="dropdown-menu dropdown-menu-md-right p-0"
                  aria-labelledby="bd-versions"> -->

                  
                  <!--  ***************commneted before only ****************-->
                  <!-- <a v-if="pluginsList.status == 'active'" class="dropdown-item p-2" @click="togglePluginStatus(pluginsList.plugin_id, pluginsList.plugin_name, true)">
                   <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#c5c0c0" style="margin-inline-end: 4px" class="bi bi-x-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                    </svg>
                    Deactivate</a>
                  <a v-else class="dropdown-item p-2" @click="togglePluginStatus(pluginsList.plugin_id, pluginsList.plugin_name,false)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#c5c0c0" class="bi bi-check-circle" viewBox="0 0 16 16">
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                      <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
                    </svg>
                    Activate</a> -->
                  <!-- *****************till here **************-->  
                  <!-- <a
                    class="dropdown-item p-2"
                    @click="uninstallPlugin(pluginsList.plugin_id, pluginsList.plugin_name, pluginsList.category)">
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 16 16"
                      class="bi bi-trash-fill"
                      style="margin-inline-end: 4px"
                      fill="#c5c0c0"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        fill-rule="evenodd"
                        d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7z"
                      />
                    </svg>
                    Uninstall</a>
                </div>
              </div> -->
            <!-- </td> -->
          </tr>
        </tbody>
      </table>
    </div>
     <div>
    <!-- <pagination
        v-model="page"
        :records="totalUsers"
        :per-page="perPage"
        @paginate="paginate"
        style="margin-top:10px"
    />
    </div> -->
    </div>
</div>
</template>


<script>
import { mapActions, mapMutations } from "vuex";
import Constants from "../../components.constants.js";
import Utils from "../../components.utils.js";
// import Pagination from "vue-pagination-2";


export default {
  props: ["userId"],
  data() {
    return {
      page: 1,
      pluginsList: [],
      isHidden: null,
      search: null,
      totalPages: -1,
      totalUsers: -1,
      perPage: -1,
      component:null
    };
  },
  components:{
    // pagination: Pagination,
  },
  emits: ["changeSelectedPluginComponent"],
  methods: {
    replaceByDefaultImage(e){
      e.target.onerror = null
      e.target.src = Utils.getNoThumbnailImg();
    },
    paginate(page) {
      this.page = page;
    //   this.updateUsersList();
    },
    changeComponent(pluginInfo){
      this.$emit("changeSelectedPluginComponent", "plugin-config",pluginInfo);
    },
    uninstallPlugin(pluginId, pluginName, pluginCategory) {
      if (
        confirm(
          `Are You sure you want to uninstall the selected "${pluginName}" plugin ?`
        )
      ) {
        let payload = {
          "plugin_id":pluginId,
          "command": "PLUGIN_UNINSTALL",
          "plugin_name": pluginName,
          "category":pluginCategory
        }
        this.uninstallExistingPlugin(payload).then((data) => {
          if (Utils.isAcceptedStatusCode(data.statusCode)) {
            this.$toast.success(data.message);
            this.pluginsList =  this.pluginsList.filter(pluginInfo => pluginInfo.plugin_id != pluginId)
          } else {
            this.$toast.error(data.message);
          }
        });
      }
    },
    togglePluginStatus(pluginId, pluginName, deactivatePlugin) {
        console.log(pluginId,pluginName)
      if(deactivatePlugin){
        return
      }
    },
    updateNewInstalledPlugin(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      let addedPluginData = notification.message.data;
      if(notification.message_type == "PLUGIN_UPGRADED"){
        let pluginIdx = this.pluginsList.findIndex(plugin=>plugin.plugin_id == addedPluginData.plugin_id);
        if(pluginIdx >=0 && this.pluginsList[pluginIdx]){
          this.pluginsList[pluginIdx].status = addedPluginData.status;
          this.pluginsList[pluginIdx].modified_datetime = addedPluginData.modified_datetime;
          this.pluginsList[pluginIdx].plugin_version.version = addedPluginData.plugin_version.version;
          this.pluginsList[pluginIdx].plugin_name = addedPluginData.plugin_name;
        }
      }else if(notification.message_type == "PLUGIN_INSTALLED"){
        let pluginIdx = this.pluginsList.findIndex(plugin=>plugin.plugin_id == addedPluginData.plugin_id);
        if(pluginIdx == -1){
          this.pluginsList.push(addedPluginData);
        }  
      }

      this.filteredPlugins();
    },

    updateUnInstalledPlugin(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      // var pluginNameByNotification = notification.message.plugin_name;
       this.pluginsList = this.pluginsList.filter(e => e.plugin_name != notification.message.plugin_name);
    },
    ...mapActions("pluginRepo", ["getInstalledPluginsFromServer","uninstallExistingPlugin"]),
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
  },
  created() {
    this.getInstalledPluginsFromServer().then((data) => {
        if(Object.keys(data).includes("plugins")){
          this.pluginsList = data.plugins;
        }
      });
    // this.updateUsersList();
    this.addWSEventListener({eventname:Constants.plugininstalledNotification, callback:this.updateNewInstalledPlugin, parent:"PluginsTable"}); 
    this.addWSEventListener({eventname:Constants.pluginupgradedNotification, callback:this.updateNewInstalledPlugin, parent:"PluginsTable"}); 
    this.addWSEventListener({eventname:Constants.pluginUninstalledNotification, callback:this.updateUnInstalledPlugin, parent:"PluginsTable"}); 
  },
  beforeDestroy(){
    this.removeWSEventListener({eventname:Constants.plugininstalledNotification, callback:this.updateNewInstalledPlugin, parent:"PluginsTable"}); 
    this.removeWSEventListener({eventname:Constants.pluginupgradedNotification, callback:this.updateNewInstalledPlugin, parent:"PluginsTable"}); 
    this.removeWSEventListener({eventname:Constants.pluginUninstalledNotification, callback:this.updateUnInstalledPlugin, parent:"PluginsTable"}); 
  },
  computed: {
    filteredPlugins() {
    if(this.search != null){
      if (!this.pluginsList.length) {
          return [];
        }
        return this.pluginsList.filter((item) => {
          const pluginName = item.plugin_name.toLowerCase();
          const searchTerm = this.search.toLowerCase();
          return pluginName.includes(searchTerm);
        });
      }else{
        return this.pluginsList;
      }
    },
  },
};
</script>


<style scoped lang="scss">
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;


.activeclass {
  color: $active-blue;
}

.table-scroll {
  /*width:100%; */
  border: none !important;
  /* Decoration */
  border-spacing: 0;
  width: 100%;
  thead {
    color: $dull-text-color !important;
    position: relative;
    th{
      position: sticky;
      top: 0;
      z-index:9;
      text-align: start;
      background: $primary-background;
    }
  }
  tbody {
    width: 100%;
    overflow: auto;
    font-weight: 500;
    tr{
    height:40px;
    }
  }
}

.table{
  th{
    border-top:none !important;
  }
  td{
    border-top:none !important;
  }
}

.comm-user-row:hover {
  color: $active-blue;
  background: $bg-color-on-hover;
  td:first-child {
    text-decoration: underline;
  }
}

// .height-set-for-component {
//   height: calc(100% - 150px);
// }

table .more-actions-btn {
  visibility: hidden;
}
table tr:hover .more-actions-btn {
  visibility: visible;
}

.search-bar-comm-style {
    // inset-inline-end :16px;
    height: 50px;
    position: relative;
    // bottom: 20px;
    margin:20px;
  .search-bar{
    background: $primary-background!important;
    height:40px;
    width: 250px !important;
    float: inline-start;
    // margin-inline-start: 3%;
    padding-inline-start: 12px;
    padding-bottom: 2px;
    border: $border-color !important;
  }
}

.show-delete-icon:hover{
    position: relative;
    .parent-row-delete,  .parent-row-edit{
        visibility: visible;
    }
}

.parent-row-delete, .parent-row-edit{
    margin-inline-start: 3px;
    z-index: 1;
    background: #525252;
    border: 1px solid #262626;
    width: 115px;
    height: 44px;
    padding: 12px;
    top: 0px;
    border-radius: 4px;
    visibility: hidden;
    color: #fff;
    position: absolute;
    inset-inline-end: 0px;
    text-decoration: none !important;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

.activestatus {
  color: #28a745 !important;
}

::v-deep {
.page-item.disabled .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none;
        }
        .page-item.active .page-link {
            background-color: $secondary-background-color !important;
            // border: none !important;
            border: $border-color !important;
            color: $active-blue;
            z-index: 0 !important;
        }
        .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none !important;
            color: $text-color;
            padding: 5px !important;
        }
        .page-link:hover {
            background-color: $bg-color-on-hover !important;
        }
        .pagination {
            float: inline-end;
            margin-bottom: 0px !important;
            margin-inline-end: 8px;
        }
        .VuePagination__count {
            color: $secondary-text-color !important;
            margin-bottom: 0px !important;
            font-size: 12px;
            margin-inline-end: 7px;
            margin-top: 1px;
            float:inline-start;
            display:none;
            margin-inline-start:5px;
        }
        .VuePagination__pagination-item {
            font-size: 14px;
            width: 27px;
        }
        .VuePagination__pagination-item-prev-chunk {
            display:none;
        }
        .VuePagination__pagination-item-next-chunk{
            display:none;
        }

        .VuePagination__pagination-item-prev-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page a:before{
            width:50px;
            content: "next ";
        }

        .VuePagination__pagination-item-prev-page a:after{
            width:50px;
            content: " prev";
        }
        .v-list{
            padding:0px !important;
        }
        .v-list-item{
            text-align: start;
            border: $border-color !important;
            min-height: 37px !important;
            padding: 0 10px !important;
            font-size: 12px !important;
            .v-list-item__title{
                    font-size: 14px !important;
                    color:$text-color !important;
            }
            }
        .v-menu__content{
            width:150px !important;
        }
}
</style>
